// libraries
import { createSlice } from '@reduxjs/toolkit';
// store
import { RootState } from '@store';
import {
  BodyHermesCO,
  BodyHermesMX,
  HermesMessageCO,
  HermesMessageMX,
} from '../interfaces/interfaces';

interface HermesDataState {
  hermesData: HermesMessageCO | HermesMessageMX | null;
  hermesDataBody: BodyHermesCO | BodyHermesMX | null;
}

// Estado inicial solo con hermesData
export const initialState: HermesDataState = {
  hermesData: null,
  hermesDataBody: null,
};

export const domainHermesDataSlice = createSlice({
  name: 'domainHermesDataSlice',
  initialState,
  reducers: {
    setHermesData: (state, action) => {
      state.hermesData = action.payload;
    },
    setHermesDataBody: (state, action) => {
      const { formData, leadDetailData } = action.payload;

      state.hermesDataBody = {
        ...formData,
        ...leadDetailData,
      };
    },
    setDefaultState: () => {
      return initialState;
    },
  },
});

export const { setHermesData, setHermesDataBody, setDefaultState } =
  domainHermesDataSlice.actions;

// Selectors.
export const getHermesData = (state: RootState) =>
  state.domainHermesData.hermesData;

export const getHermesDataBody = (state: RootState) =>
  state.domainHermesData.hermesDataBody;

export default domainHermesDataSlice.reducer;
